import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchUserAllAssessments, getAllParticipantsOfAssessment, updateAsmtStatus } from '../../services/authService';
import { useAuth } from '../../context/AuthContext';
import ParticipantCard from './PartcipantCard';
import ConfirmationModal from './ConfrimationModel';
import SendReminEmail from './SendRemin';
import { decodeId } from '../../utills/idUtils';
import FancyLoader from '../../hooks/FancyLoder';

const ParticipantDetails = () => {
    const { encodedId } = useParams();
    const id = decodeId(encodedId)
    const { state } = useAuth();
    const { user } = state;

    const [participants, setParticipants] = useState([]);
    const [assessmentStatus, setAssessmentStatus] = useState(''); // Store the assessment status
    const [loadingParticipants, setLoadingParticipants] = useState(true);
    const [loadingAssessment, setLoadingAssessment] = useState(true);
    const [error, setError] = useState(null);
    const [useridArr, setUserIdarr] = useState(null)
    const [send, setSend] = useState(false);
    const [confirm, setConfirm] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");

    console.log(participants, "parparticipantsticipants")

    const userId = user?.user_id;

    useEffect(() => {
        if (!userId || !id) return;
        setUserIdarr(id);
        // Fetch participants



        const fetchParticipants = async () => {
            try {
                const res = await updateAsmtStatus(id, userId);
                //console.log("res==>", res)
                const participantResponse = await getAllParticipantsOfAssessment(id);
                ////console.log('Participants:', participantResponse.data);
                setParticipants(participantResponse.data);
            } catch (err) {
                setError(`Failed to fetch participants: ${err.message}`);
            } finally {
                setLoadingParticipants(false);
            }
        };

        // Fetch assessment details
        const fetchAssessmentDetails = async () => {
            try {
                const assessmentResponse = await fetchUserAllAssessments(userId);
                ////console.log('Assessment Details:', assessmentResponse.initiatorAssessments);
                const selectedAssessment = assessmentResponse.initiatorAssessments.find(
                    assessment => assessment.assessment_id === parseInt(id)
                );
                if (selectedAssessment) {
                    setAssessmentStatus(selectedAssessment);
                } else {
                    setError('Assessment not found');
                }
            } catch (err) {
                setError(`Failed to fetch assessment: ${err.message}`);
            } finally {
                setLoadingAssessment(false);
            }
        };

        fetchParticipants();
        fetchAssessmentDetails();
    }, [id, userId]);


    if (loadingParticipants || loadingAssessment) return <div><FancyLoader /></div>;

    if (error) return <div>Error: {error}</div>;

    const pendingParticipants = participants.filter(p => p.status === 'Pending');
    const completedParticipants = participants.filter(p => p.status === 'Completed');
    const expiredParticipants = participants.filter(p => p.status === 'Expired');

    const isInitiatorPending = participants.some(
        p => p.association_type === 'initiator' && p.status !== 'Completed'
    );


    const handleSuccessMessage = (message) => {
        setSuccessMsg(message);

        setTimeout(() => {
            setSend(false)
            setSuccessMsg('');
        }, 3000);
    };
    const handleSendReminder = () => {
        setConfirm(true);
    };

    const handleConfirmSend = () => {
        ////console.log("Sending reminders...");
        setSend(true);
        handleSuccessMessage("Reminder email sent successfully!"); // Call the success message handler
        setConfirm(false);
    };

    const handleCancelSend = () => {
        setConfirm(false);
    };

    return (

        <div className="flex flex-col items-center">

            {assessmentStatus?.current_status !== 'Completed' && isInitiatorPending && (
                // {true && (
                <div className="w-11/12 mt-6 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 rounded shadow">
                    <div className="flex items-center">
                        <span className="text-2xl mr-3">⚠️</span>
                        <div>
                            <p className="font-semibold text-lg">Action Required</p>
                            <p>Please complete your self-assessment to enable the generation of your 360-degree feedback report.</p>
                        </div>
                    </div>
                </div>
            )}



            <div className="w-full bg-blue-600 text-white text-center py-4">
                <h1 className="text-2xl font-bold">Result for {user.first_name}</h1>
                <div className="flex justify-between px-4 mt-2">
                    <span>Started: {new Date(assessmentStatus.initiation_date).toLocaleDateString()}</span>
                    <span>
                        Status: {assessmentStatus.current_status}
                        {assessmentStatus.expected_completion_date &&
                            `, Expected Completion: ${new Date(assessmentStatus.expected_completion_date).toLocaleDateString()}`}
                    </span>
                </div>

            </div>

            <div className="flex align-middle">   {successMsg && (
                <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mt-4 flex items-center">
                    <span className="mr-2">✅</span>
                    {successMsg}
                </div>
            )}
                <SendReminEmail id={useridArr} send={send} onSuccess={handleSuccessMessage} />
            </div>
            {/* Pending Participants */}
            {pendingParticipants.length > 0 &&
                <div className="bg-amber-50 p-6 mt-4 rounded-lg shadow-lg w-11/12">
                    <h2 className="text-xl font-semibold mb-4" style={{ fontFamily: "Helvetica" }}
                    >Respondents - Pending</h2>
                    <div className="border-2 border-dashed border-purple-400 p-4">
                        <div className="flex flex-wrap justify-between">
                            {
                                pendingParticipants.map(participant => (
                                    <ParticipantCard key={participant.assessment_user_id} participant={participant} />
                                ))
                            }
                        </div>
                    </div>
                    <div className='my-2 lg:flex justify-center items-center'>
                        <button
                            onClick={handleSendReminder}
                            className="bg-blue-600 text-white font-bold py-2 px-4 rounded mt-4"
                        >
                            Send Reminders
                        </button>

                        {confirm && (
                            <ConfirmationModal
                                onConfirm={handleConfirmSend}
                                onCancel={handleCancelSend}
                            />
                        )}
                    </div>
                </div>
            }

            {/* Completed Participants */}
            {completedParticipants.length > 0 &&
                <div className="bg-green-50 p-6 mt-4 rounded-lg shadow-lg w-11/12">
                    <h2 className="text-xl font-semibold mb-4" style={{ fontFamily: "Helvetica" }}>Respondents - Completed</h2>
                    <div className="border-2 border-dashed border-purple-400 p-4">
                        <div className="flex flex-wrap justify-between">
                            {
                                completedParticipants.map(participant => (
                                    <ParticipantCard key={participant.assessment_user_id} participant={participant} />
                                ))
                            }
                        </div>
                    </div>
                </div>
            }

            {/* Expired Participants */}
            {expiredParticipants.length > 0 && (
                <div className="bg-red-50 p-6 mt-4 rounded-lg shadow-lg w-11/12 mb-5">
                    <h2 className="text-xl font-semibold mb-4" style={{ fontFamily: "Helvetica" }}
                    >
                        {/* Respondents - Expired */}
                        Feedback Not Received (Window Closed)
                    </h2>
                    <div className="border-2 border-dashed border-purple-400 p-4">
                        <div className="flex flex-wrap justify-between">
                            {expiredParticipants.map(participant => (
                                <ParticipantCard key={participant.assessment_user_id} participant={participant} />

                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );


};

// ParticipantCard Component to display individual participant details


export default ParticipantDetails;
